module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/customize_mobile-6a03f1338603be1a7bd05f5f352a14c0.webp";